import nr from 'nr'
const api = nr.loadScript('api-common')
const memory = nr.loadScript('memory')
const urlBase = memory.urlBase
const getData = api.getCommonData
const request = api.request

export function searchCmsMedia (success) {
  getData(urlBase + "indexNew/searchCmsMedia", {},success);
}
export function mbGetMedia (type, keyword, pageNumber, pageSize, success) {
  getData(urlBase + "index/mbGetMedia", {type: type, keyword: keyword,pageNumber: pageNumber,pageSize: pageSize},success);
}
export function mbSearchNews (type, success) {
  getData(urlBase + "indexNew/mbSearchNews", {type: type},success);
}
export function newrankExhibition(success) {
  getData(urlBase + "indexNew/newrankExhibition", {},success);
}
export function showData(url,success) {
  getData(urlBase + "login/wxyz/showdata", {url: url},success);
}
export function mbGetBannerList(pageSize, type, success) {
  getData(urlBase + 'sys/banner/m/mbGetBannerList', {pageSize: pageSize, type: type}, success);
}
//根据uuid  登陆
export function authUserInfo(code, uuid, success) {
  getData(urlBase + 'login/wxyz/authUserInfo', { code: code, uuid: uuid }, success);
}
// 群审核获取信息
export function getApplyGroupInfo(applyId, success,fail) {
  request({
    'url': urlBase + 'qbb/v1/api/group/getApplyGroupInfo',
    'method': 'GET',
    'param': {applyId: applyId},
    'success': success,
    'error': fail
  })
}
//群审核
export function auditApplyGroup(applyId, type, auditMemo, success) {
  getData(urlBase + 'qbb/v1/api/group/auditApplyGroup', {applyId: applyId, type: type, auditMemo: auditMemo}, success);
}
export function countAuditsRecordByUser(success, fail) {
  request({
    'url': urlBase + 'erp/audit/countAuditsRecordByUser',
    'method': 'GET',
    'success': success,
    'error': fail
  })
}
export function getAccountInfo (id, success, fail) {
  request({
    'url': urlBase + 'annual/h5/getCheckDataById',
    'method': 'GET',
    'param': {id: id},
    'success': success,
    'error': fail
  })
}

export function audit (params, success, fail) {
  getData(urlBase + 'annual/h5/check', {
    id: params.id,
    reason: params.reason,
    type: params.type
  }, success, fail)
}

export function getUserNoticeCount(success) {
  getData(urlBase + 'main/v1/common/getUserNoticeCount', {}, success);
}

export function receiveMoney(token,code,xoi,success,fail) {
  request({
    'url': urlBase + 'v1/weixin/callback/receiveMoney',
    'method': 'POST',
    'param': {'token':token,'code':code,'xoi':xoi},
    'success': success,
    'error': fail
  })
}

export function checkRedReceiver(code,xoi,success,fail) {
  request({
    'url': urlBase + 'v1/weixin/callback/checkRedReceiver',
    'method': 'POST',
    'param': {'code':code,'xoi':xoi},
    'success': success,
    'error': fail
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api/index.js